import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'

interface CurrentWalletStore {
  currentWallet: string
  setCurrentWallet: (walletId: string) => void
}

export const createCurrentWalletStore = (storage: StateStorage) =>
  createStore<CurrentWalletStore>(
    storage,
    (set) => ({
      currentWallet: '',
      setCurrentWallet(walletId) {
        set({ currentWallet: walletId })
      },
    }),
    {
      persist: {
        name: 'currentWallet',
        version: 0,
      },
    }
  )
